module.exports = __webpack_public_path__ + "media/customizations/furstranch/back-1076ae71bd1fd3e1697c169275473579.jpg";